import React, {Component} from 'react';
import { CONFIG } from '../config.js';


export default class GoogleReCaptcha extends Component{
	 constructor(props){
		super(props);
		this.state = {showCaptchaError: this.props.showCaptchaError}
	}
  
	onloadCaptcha = () => {
		this.props.callbackFromParent({
			recaptchaInstance: this.recaptchaInstance,
			captchaResponse: ''
		});
		
	}
	
	componentWillReceiveProps = (props) => {
		this.setState({showCaptchaError: props.showCaptchaError})
	}
	
	// executed once the captcha has been verified
	// can be used to post forms, redirect, etc.
	verifyCaptchaCallback = (response) => {
		this.setState({showCaptchaError: false});
		if(!response || response.trim().length === 0){
			this.props.callbackFromParent({
				recaptchaInstance: this.recaptchaInstance,
				captchaResponse: '',
				validCaptcha: false
			});
		}
		else{
			this.props.callbackFromParent({
				recaptchaInstance: this.recaptchaInstance,
				captchaErrorMsg: '',
				captchaResponse: response,
				validCaptcha: true
			});
		}
	}

	resetCaptchaState = () => {
		this.recaptchaInstance.reset();
		this.setState({showCaptchaError: false});
		this.props.callbackFromParent({
			recaptchaInstance: this.recaptchaInstance,
			captchaResponse: '',
			validCaptcha: false
		});
	}
		
	render(){
		let ReCAPTCHA = require("react-recaptcha");
		return (
			<div className="captcha-div">
				<div>
					<ReCAPTCHA
						ref={ e => this.recaptchaInstance = e }
						sitekey = {CONFIG.GOOGLE_SITE_KEY}
						render="explicit"
						onloadCallback={this.onloadCaptcha}
						verifyCallback = {this.verifyCaptchaCallback}/>
				</div>
			</div>
			
		);
	}
}
